import { inject, observer } from 'mobx-react';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import styled from '@emotion/styled';
import { Instance } from 'mobx-state-tree';
import { TLCode } from '../../common/enums';
import { DutyExchangeItem } from '../../store/models/DutyExchangeItem';
import { Intent, Spinner } from '@blueprintjs/core';
import { saveAs } from 'file-saver';
import { renderGridDateTimeWithDetails, renderGridDateWithDay } from '../../store/utils';
import { SystemStatusStore } from '../../store';
import { SystemStatus } from '../../store/models/SystemStatus';
import {
    DataGrid,
    Column,
    SearchPanel,
    DataGridTypes,
    Export,
    FilterRow,
    HeaderFilter,
    Pager,
    Paging,
    Toolbar,
    Item,
    ColumnChooser,
    FilterPanel,
    Sorting,
} from 'devextreme-react/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { Container } from '../common/styledComponents/StyledComponents';
import { PharmacyDetails } from '../../store/models';
import PharmacyDetail from '../Exchanges/PharmacyDetail';

interface PharmacyComparedDataProps extends WithTranslateProps {
    isLoading: boolean;
    SystemStatusStore?: Instance<typeof SystemStatusStore>;
    pharmacy?: Instance<typeof PharmacyDetails>;
}

interface PharmacyComparedDataState {
    filter: string;
    systemStatus?: Array<Instance<typeof SystemStatus>>;
}

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 5px;
`;

const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

@inject('SystemStatusStore')
@observer
class PharmacyComparedData extends React.Component<PharmacyComparedDataProps, PharmacyComparedDataState> {
    constructor(props: PharmacyComparedDataProps) {
        super(props);
        this.state = {
            filter: '',
        };
    }

    _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
    }

    // onExporting = (e: DataGridTypes.ExportingEvent) => {
    //     const workbook = new Workbook();
    //     const worksheet = workbook.addWorksheet('Main sheet');

    //     exportDataGrid({
    //         component: e.component,
    //         worksheet,
    //         autoFilterEnabled: true,
    //     }).then(() => {
    //         workbook.xlsx.writeBuffer().then((buffer) => {
    //             if(!this.props.pharmacy){
    //                 saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PharmacyComparedData.xlsx');
    //             }
    //             else{
    //                 saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PharmacyComparedData-' + this.props.pharmacy.apbNumber + '.xlsx');
    //             }
    //         });
    //     });
    // };

    render() {
        const { translate, isLoading, pharmacy } = this.props;
        
        return (
            <Container>
                {isLoading ? (
                    <SpinnerContainer>
                        <Spinner intent={Intent.PRIMARY} size={Spinner.SIZE_STANDARD} />
                    </SpinnerContainer>
                ) : (
                    <>
                        <DivLine />
                        {pharmacy!.apbLatitude}<br/>
                        {pharmacy!.x}&nbsp;{pharmacy!.apbX}&nbsp;{pharmacy!.afmpsX}<br/>
                        {pharmacy!.y}&nbsp;{pharmacy!.apbY}&nbsp;{pharmacy!.afmpsY}<br/>
                    </>
                )}
            </Container>
        );
    }
}

export default withTranslate(PharmacyComparedData);
